import { formatRetryAfter } from "./format";

// Server-side rate limits answer with { error, scope, retryAfter }. These turn
// that into prose, so no screen has to render the raw JSON — and so the wording
// for a given scope stays identical wherever it surfaces.

export type RateLimitPayload = {
  error?: string;
  scope?: string;
  retryAfter?: unknown;
};

export function asRateLimitPayload(value: unknown): RateLimitPayload {
  return value && typeof value === "object" ? (value as RateLimitPayload) : {};
}

const INVITE_SCOPE_TEXT: Record<string, string> = {
  project: "このプロジェクトからの招待送信",
  actor: "あなたからの招待送信",
  target: "このメールアドレス宛の招待送信",
};

export function inviteRateLimitMessage(payload: RateLimitPayload): string {
  const what = INVITE_SCOPE_TEXT[payload.scope ?? ""] ?? "招待送信";
  return `${what}が上限に達しました。${formatRetryAfter(payload.retryAfter)}ほど時間をおいてからお試しください。招待済みのメンバーはそのまま残っています。`;
}

export function aiRateLimitMessage(payload: RateLimitPayload): string {
  if (payload.error === "ai_busy") {
    return "前のリクエストがまだ処理中です。完了してからもう一度お試しください。";
  }
  const what =
    payload.scope === "vision"
      ? "画像を参照する依頼の利用上限"
      : payload.scope === "project"
        ? "このプロジェクトの AI 利用上限"
        : "AI の利用上限";
  return `${what}に達しました。${formatRetryAfter(payload.retryAfter)}ほど時間をおいてからお試しください。`;
}
